import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROFILE_API } from "./apiRoutes";

const mutateProfile = async () => {
  return await axiosAuth.get(PROFILE_API);
};

const useProfileMutation = (
  queryParams?: UseMutationOptions<any, Error, void, unknown>
) =>
  useMutation({
    mutationFn: mutateProfile,
    ...queryParams,
  });

export default useProfileMutation;